<script setup lang="ts">
import { useAppStore } from '@/stores/app'
import { computed } from 'vue'
import CommentPc from './pc.vue'
import CommentMobile from './mobile.vue'

const appStore = useAppStore()

const props = defineProps<{
  show: boolean
  episodeId: number
  scriptId: number
}>()

const emit = defineEmits<{
  (e: 'update:show', value: boolean): void
}>()

const mobileShow = computed({
  get: () => props.show,
  set: (value: boolean) => emit('update:show', value),
})
</script>

<template>
  <CommentMobile v-if="appStore.isMobile" v-model:show="mobileShow" :episode-id="episodeId" :script-id="scriptId" />

  <CommentPc v-else-if="show" :episode-id="episodeId" :script-id="scriptId" @close="emit('update:show', false)" />
</template>
